import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setAuthToken, setUserInfo } from '../../actions/index';
import config from '../../../config';

class AuthReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'Signing you in...',
      hasError: false,
    };
    this.processed = false;
  }

  componentDidMount() {
    if (this.processed) return;
    this.processed = true;
    this.finishLogin();
  }

  finishLogin = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (!code) {
        throw new Error('No authorization code found');
      }

      // Exchange the one-time code for tokens from the proxy
      const tokenResponse = await fetch(
        `${config.onDemandOauthBaseUrl}/new-auth/on-demand/token`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        }
      );

      const tokenData = await tokenResponse.json();

      if (!tokenResponse.ok) {
        throw new Error(tokenData.message || 'Failed to exchange auth code');
      }

      const { idToken } = tokenData;

      if (!idToken) {
        throw new Error('Proxy did not return an ID token');
      }

      // Clear the code from URL to prevent replay
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', '/auth/return');
      }

      // Use the idToken to login via the existing network backend endpoint
      const loginResponse = await fetch(
        `${config.apiBaseUrl}/network/oauth/login`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: idToken }),
        }
      );

      const loginData = await loginResponse.json();
      const authorization = loginResponse.headers.get('authorization');

      if (!loginResponse.ok || loginData.message !== 'loggedIn') {
        throw new Error(loginData.message || 'Login failed');
      }

      // Dispatch auth info to Redux store
      const { dispatch, history } = this.props;
      dispatch(setUserInfo(loginData.operatorDetails));
      dispatch(setAuthToken(authorization));

      // Redirect to home
      history.push('/home');
    } catch (err) {
      console.error('AuthReturn error:', err);
      this.setState({
        status: err.message || 'Authentication failed',
        hasError: true,
      });
      // Redirect back to login after a brief delay
      setTimeout(() => {
        this.props.history.push('/');
      }, 2000);
    }
  };

  render() {
    const { status, hasError } = this.state;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'sans-serif',
        }}
      >
        {!hasError && (
          <div
            style={{
              width: 40,
              height: 40,
              border: '4px solid #e0e0e0',
              borderTopColor: '#00b7b7',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginBottom: 20,
            }}
          />
        )}
        <p style={{ color: hasError ? '#d32f2f' : '#333', fontSize: 16 }}>
          {status}
        </p>
        {hasError && (
          <p style={{ color: '#666', fontSize: 14 }}>
            Redirecting to login...
          </p>
        )}
        <style>
          {`@keyframes spin { to { transform: rotate(360deg); } }`}
        </style>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(AuthReturn);
